import { render, staticRenderFns } from "./PriceType.vue?vue&type=template&id=61c3aca0&"
import script from "./PriceType.vue?vue&type=script&lang=js&"
export * from "./PriceType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports